import { render } from "./FieldBoolean.vue?vue&type=template&id=4f40f8b9&lang=pug"
import script from "./FieldBoolean.vue?vue&type=script&lang=js"
export * from "./FieldBoolean.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__